import { API_URL } from "../../../constants";
import * as httpNetworking from "../../../httpNetworking";

const URL = API_URL + "/organization/member";
const VERSION = 0;

export default async function deleteMember(userId: string): Promise<void> {
    const params = {
        userId
    };
    const options: httpNetworking.DELETERequestConfig = {
        timeout: 50000,
        params
    };

    const response = (await httpNetworking.simpleDELETERequest(URL, options, VERSION)).data;
    return response;
}
